export default __webpack_public_path__ + "static/media/1811.015847e6.png";